import { notifications } from '@mantine/notifications';
import type { WoltMenuSyncResult } from 'shared-models/browser';

// One toast per sync: green when everything went, yellow with the skipped reasons otherwise.
export function notifyWoltMenuSync(result: WoltMenuSyncResult): void {
  const summary = `נשלחו ${result.itemCount} פריטים ו-${result.optionGroupCount} קבוצות אפשרויות לוולט`;
  if (result.skipped.length === 0) {
    notifications.show({ color: 'green', title: 'התפריט סונכרן', message: summary, autoClose: 4000 });
    return;
  }
  notifications.show({
    color: 'yellow',
    title: `התפריט סונכרן, ${result.skipped.length} פריטים דולגו`,
    message: `${summary}. דולגו: ${result.skipped.join(' | ')}`,
    autoClose: 8000,
  });
}
